if (!customElements.get('related-product-card')) {
  customElements.define(
    'related-product-card',
    class RelatedProductCard extends HTMLElement {
      connectedCallback() {
        this.activeImage = this.querySelector('[data-related-card-image]');
        this.nextImage = this.querySelector('[data-related-card-image-next]');
        this.swatches = Array.from(this.querySelectorAll('.related-product-card__swatch'));
        this.selectedSrc = this.activeImage ? this.activeImage.src : null;

        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => this.selectSwatch(swatch));
          swatch.addEventListener('mouseenter', () => this.previewSwatch(swatch));
          swatch.addEventListener('mouseleave', () => this.restoreSelected());
        });

        // Colour picked by a collection filter but not among the swatches shown: no swatch is marked instead.
        const initialSwatch =
          this.querySelector('[data-initially-selected]') || (this.hasAttribute('data-filtered-color') ? null : this.swatches[0]);
        if (initialSwatch) {
          initialSwatch.classList.add('is-selected');
          initialSwatch.setAttribute('aria-pressed', 'true');
        }
      }

      // Full address of an image, to compare "//shop/cdn/…" (from Liquid) with "https://shop/cdn/…" (img.src).
      absolute(src) {
        try {
          return new URL(src, window.location.href).href;
        } catch (error) {
          return src;
        }
      }

      setImage(src) {
        if (!this.activeImage || !this.nextImage || !src) return;
        // Same photo as the one shown (e.g. hovering the selected color): no fade.
        if (this.absolute(src) === this.absolute(this.activeImage.currentSrc || this.activeImage.src)) return;

        this.nextImage.src = src;
        this.nextImage.classList.add('is-active');
        this.activeImage.classList.remove('is-active');

        // Swap references so the newly-visible image becomes "active" for the next transition.
        const previous = this.activeImage;
        this.activeImage = this.nextImage;
        this.nextImage = previous;
      }

      previewSwatch(swatch) {
        this.setImage(swatch.dataset.imageSrc);
      }

      restoreSelected() {
        this.setImage(this.selectedSrc);
      }

      selectSwatch(swatch) {
        const imageSrc = swatch.dataset.imageSrc;
        if (!imageSrc) return;

        this.setImage(imageSrc);
        this.selectedSrc = imageSrc;

        this.swatches.forEach((btn) => {
          const isSelected = btn === swatch;
          btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          btn.classList.toggle('is-selected', isSelected);
        });
      }
    }
  );
}
